// import packages
import React, { useState, useContext, useEffect } from "react";
import _ from "lodash";
import {
  Button,
  LegacyCard as Card,
  Collapsible,
  Text,
  Form,
  FormLayout,
  Layout,
  PageActions,
  BlockStack,
  InlineStack,
  Divider,
} from "@shopify/polaris";
import { ActionButton } from "app/setup/modules/operator/features/productTagSetting/style";

// import context
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

import { useMutation, useQuery } from "@apollo/client";

// import propTypes
import { advanceProp } from "app/setup/modules/operator/features/commission/props";

// import components
import { Banner, Spinner, Toast } from "lib/components";

// import helper
import { baseHelper, errorHelper } from "lib/helpers";

// import queries
import { GET_METAFIELD_SETTING } from "app/product/apollo/queries";
import { GET_MANAGE_METAFIELD_SETTING } from "app/productOld/apollo/queries";

import { UPDATE_METAFIELD } from "app/productOld/apollo/mutations";

import ProductMetafieldAdd from "app/productOld/modules/operator/features/metafield/components/add";
import { useNavigate } from "react-router-dom";
import AdvanceMetaFields from "./components/advance";
import OperatorMetafieldKeySetting from "./components/metaFieldkey";

const ProductMetafield = () => {
  const { cms = {} } = useContext(PrivateContext);
  const navigate = useNavigate();

  const [disableNameKey, setDisableNameKey] = useState([]);
  const [state, setState] = useState([]);
  const [metaData, setMetaData] = useState([]);

  // const [active, setActive] = useState(false);
  // const [collapsOpen, setCollapseOpen] = useState(false);
  const [submitEnabled, setSubmitEnable] = useState(false);

  const [banner, setBanner] = useState({ isOpen: false, status: "", title: "", message: "" });
  const [message, setMessage] = useState("");
  const [updateAt, setUpdateAt] = useState("");
  const [isAdvanceActive, setIsAdvanceActive] = useState(false);
  const [isMetaFieldEnable, setIsMetafieldEnable] = useState(false);
  const [isEnabledData, setIsEnabledData] = useState(false);
  const [keyUpdateAt, setKeyUpdateAt] = useState("");

  const selectValue = {
    weight: constant.WEIGHT,
    dimension: constant.DIMENSION,
    volume: constant.VOLUME,
    color: constant.COLOR,
    date: constant.DATE,
    dateTime: constant.DATE_TIME,
    url: constant.url,
    rating: constant.RATING,
    file: constant.FILE,
    valueType: "valueType",
    // string: constant.STRING,
  };

  const { loading: catalogLoading, data: metaFieldData, error: getProductTagSettingError, refetch } = useQuery(
    GET_METAFIELD_SETTING
  );

  const { loading: loadingManageMetaField, data: dataManageMetaField, refetch: metaketRefetch } = useQuery(
    GET_MANAGE_METAFIELD_SETTING
  );

  const [updateMetafieldSetting, { loading: updateTagSettingLoading }] = useMutation(UPDATE_METAFIELD);

  useEffect(() => {
    if (metaFieldData) {
      const metafieldSetting = baseHelper.getResponseData(metaFieldData, constant.gql.GET_METAFIELD_SETTING) || {};
      const { metafield = [], updatedAt } = metafieldSetting;
      refetch();
      setUpdateAt(updatedAt);
      if (metafield && metafield.length) {
        setState([...metafield]);
        setIsAdvanceActive(true);
        const mapMetafield = metafield.map((item) => ({ label: item.name, value: item.key }));
        setMetaData(mapMetafield);
      } else {
        setIsAdvanceActive(false);
      }
    }
  }, [metaFieldData, refetch]);

  useEffect(() => {
    if (dataManageMetaField) {
      const metaFieldkeyResponse = baseHelper.getResponseData(
        dataManageMetaField,
        constant.gql.GET_MANAGE_METAFIELD_KEYS
      );
      if (metaFieldkeyResponse) {
        const { isEnabled = {}, updatedAt } = metaFieldkeyResponse;
        setKeyUpdateAt(updatedAt);
        setIsEnabledData(isEnabled);
        setIsMetafieldEnable(isEnabled);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataManageMetaField]);

  // load product catalog data

  const updateVal = (option, val, item, isAdvance = false) => {
    setSubmitEnable(true);
    setBanner({ isOpen: false, status: "", title: "" });
    const advancedValue = state.map((el, index) => {
      if (index !== item) return el;
      const current = { ...el };
      if (option === constant.NAME) {
        current.name = null;
      }
      if (option === constant.VALUE) {
        current.value = null;
      }
      if (option === constant.VALUE && isAdvance) {
        current.value = val;
      }
      if (option === constant.VALUE_TYPE) {
        current.value = null;
      }
      if (option === constant.CONTENT_TYPE) {
        current.value = null;
        current.contentType = val;
      } else {
        if (isMetaFieldEnable && option === constant.NAME) {
          current.key = (val || "").toLowerCase();
        }
        current[option] = val;
      }
      if ([constant.JSON, constant.TRUE_FALSE, constant.MONEY].includes(val) && option === constant.CONTENT_TYPE) {
        current.value = constant.ONE;
      }
      return current;
    });

    setState(advancedValue);
  };

  const uniqueVal = (option, val, item) => {
    const advancedValue = state.map((el, index) => (index === item ? { ...el } : el));
    let isDuplicateNamespace = false;
    let isDuplicateKey = false;
    if (option === constant.NAMESPACE) {
      isDuplicateNamespace = advancedValue.find((advanceData, index) => {
        if (item !== index) {
          return (
            advanceData.key &&
            advanceData.key === advancedValue[item].key &&
            advanceData.namespace &&
            advanceData.namespace === val
          );
        }
      });
      if (isDuplicateNamespace) {
        advancedValue[item].namespace = null;
      }
    }
    if (option === constant.KEY) {
      isDuplicateKey = advancedValue.find((advanceData, index) => {
        if (item !== index) {
          return (
            advanceData.namespace &&
            advanceData.namespace === advancedValue[item].namespace &&
            advanceData.key &&
            advanceData.key === val
          );
        }
      });
      if (isDuplicateKey) {
        advancedValue[item].key = null;
      }
    }
    if (isDuplicateNamespace || isDuplicateKey) {
      setBanner({ isOpen: true, status: constant.CRITICAL, title: cms("message.error.unique") });
    }
    setState(advancedValue);
  };

  const add = () => {
    const { length } = state;
    if (length > 1) {
      const line = state[length - 1];
      const keys = Object.keys(line);
      let isInvalid = false;
      keys.forEach((key) => {
        if (key !== "isRequired" && key !== "valueType" && !line[key]) {
          isInvalid = true;
        }
      });
      if (isInvalid) {
        setBanner({ isOpen: true, status: constant.CRITICAL, title: cms("message.error.row") });
        return;
      }
    }

    const row = {
      contentType: null,
      key: null,
      name: null,
      value: null,
      namespace: isMetaFieldEnable ? constant.CUSTOM : null,
    };
    setDisableNameKey([...disableNameKey, state.length]);
    state.push(row);
    setState([...state]);
    setSubmitEnable(true);
  };

  const removeItem = (item) => {
    setSubmitEnable(true);
    state.splice(item, 1);
    const disableFields = [...disableNameKey];
    disableFields.forEach((key, index) => {
      disableFields[index] = key - 1;
    });
    setDisableNameKey(disableFields);
    setState([...state]);
  };

  const dismissBanner = () => setBanner({ isOpen: false, status: "", title: "", message: "" });

  const validateValue = () => {
    let isInvalid = false;
    let isKeyInvalid = false;
    let isNamespaceInvalid = false;
    const validation = state.every(
      (item) => [constant.JSON, constant.TRUE_FALSE, constant.MONEY].includes(item.contentType) || item.value
    );
    state.forEach((line) => {
      const keys = Object.keys(line);
      keys.forEach((key) => {
        if (key === "value" || key === "isRequired" || key === "valueType") {
          return;
        }
        if (!line[key] || !validation) {
          isInvalid = true;
        }
        if (!isMetaFieldEnable && key === constant.NAMESPACE && !isInvalid && line[key]?.length < 3) {
          isNamespaceInvalid = true;
        }
        if (key === constant.KEY && !isInvalid && line[key]?.length < 3) {
          isKeyInvalid = true;
        }
      });
      if (isInvalid) {
        setBanner({ isOpen: true, status: constant.CRITICAL, title: cms("message.error.row") });
      }
      if (!isInvalid && isKeyInvalid && isNamespaceInvalid) {
        setBanner({
          isOpen: true,
          status: constant.CRITICAL,
          title: cms("message.error.both"),
        });
      } else {
        if (!isInvalid && isKeyInvalid) {
          const messageData = isEnabledData ? cms("message.error.displayName") : cms("message.error.key");
          setBanner({ isOpen: true, status: constant.CRITICAL, title: messageData });
        }
        if (!isInvalid && isNamespaceInvalid) {
          setBanner({
            isOpen: true,
            status: constant.CRITICAL,
            title: cms("message.error.namespace"),
          });
        }
      }
    });
    return isInvalid || isKeyInvalid || isNamespaceInvalid;
  };

  // const handleToggle = useCallback(() => {
  //   setActive(!active);
  //   setCollapseOpen(!collapsOpen);
  // });

  const handleSubmit = async () => {
    try {
      if (!validateValue()) {
        const advancedValue = state.map((advanceData, index) => {
          if (advanceData.contentType === constant.MEASUREMENT && advanceData && advanceData.value) {
            return {
              ...advanceData,
              value: advanceData && _.isArray(advanceData.value) ? advanceData.value : [advanceData.value],
            };
          }
          return advanceData;
        });
        setState(advancedValue);
        setSubmitEnable(false);
        setDisableNameKey([]);

        const res = await updateMetafieldSetting({
          variables: {
            input: { metafield: state },
          },
        });
        const resData = baseHelper.getResponseData(res.data, constant.gql.UPDATE_METAFIELD);
        const resError = baseHelper.getResponseError(res.data, constant.gql.UPDATE_METAFIELD);
        if (resError) {
          setBanner({
            status: constant.CRITICAL,
            isOpen: true,
            title: resError,
          });
        }
        if (resData && !updateAt && validateValue) {
          setMessage(cms("message.success.metafield"));
        }
        if (resData && validateValue) {
          setMessage(cms("message.success.update"));
        }
        setTimeout(() => {
          // navigate("/products");
        }, 1500);
        refetch();
      }
    } catch (exception) {
      setBanner({
        isOpen: true,
        status: constant.CRITICAL,
        title: errorHelper.parse(exception),
      });
    }
  };

  // const contentStatus = active ? constant.displayStatus.DISABLE : constant.ENABLE;

  if (catalogLoading || loadingManageMetaField) {
    return <Spinner />;
  }

  return (
    <>
      <div className="metafield-card">
        <OperatorMetafieldKeySetting
          metaketRefetch={metaketRefetch}
          isEnabledData={isEnabledData}
          setIsEnabledData={setIsEnabledData}
          keyUpdateAt={keyUpdateAt}
          navigate={navigate}
        />
        <Layout.AnnotatedSection title={cms("title")} description={cms("description")}>
          <Card
            title={[
              cms("cardTitle"),
              <Text as="span" tone="subdued">
                {updateAt && <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updateAt)}`}</Text>}
              </Text>,
            ]}
          >
            <Card.Section>
              <BlockStack gap="2">{cms("cardDescription")}</BlockStack>
              {/* <div className="toggle-action">
                <Card>
                  <InlineStack wrap={false} blockAlign="center" align="end">
                    <BlockStack gap={{ xs: "400", sm : "500"}}>
                      <Text as="span" fontWeight="semibold">{cms("title")}</Text>
                      <div className="card-discription">
                        <BlockStack gap="2">{cms("cardDescription")}</BlockStack>
                      </div>
                    </BlockStack>
                    <Box width="100%">
                      <InlineStack>
                        <Button
                          role="switch"
                          onClick={() => handleToggle}
                          tone={active ? "critical" : "success"}
                          ariaChecked={active}
                        >
                          contentStatus
                        </Button>
                      </InlineStack>
                    </Box>
                  </InlineStack>
                </Card>
            </div>
          <br /> */}
              <br />
              <Collapsible
                open
                id="advancedCommission"
                transition={{ duration: "500ms", timingFunction: "ease-in-out" }}
                expandOnPrint
              >
                {banner.isOpen && (
                  <>
                    <Banner
                      isOpen={banner.isOpen}
                      status={banner.status}
                      title={banner.title}
                      isScrollTop={false}
                      onDismiss={() => dismissBanner()}
                    >
                      {banner.message}
                    </Banner>
                    <br />
                  </>
                )}
                <Form>
                  <FormLayout>
                    <div className="meta-field-wrapper">
                      <BlockStack>
                        <ProductMetafieldAdd
                          advancedValue={state}
                          removeItem={removeItem}
                          updateVal={updateVal}
                          count={state.length}
                          uniqueVal={uniqueVal}
                          disableNameKey={disableNameKey}
                          selectValue={selectValue}
                          isMetaFieldEnable={isMetaFieldEnable}
                        />
                      </BlockStack>
                    </div>
                  </FormLayout>

                  <Button variant="plain" id="addLink" onClick={add}>
                    {`+${cms("label.metafield")}`}
                  </Button>
                  <br />
                  <br />
                  <Divider />
                  <br />

                  {updateAt && (
                    <InlineStack align="space-between" blockAlign="center">
                      <Button onClick={() => navigate("/setting")}>{cms("common.button.cancel")}</Button>
                      <Button
                        onClick={() => handleSubmit()}
                        disabled={!submitEnabled}
                        loading={updateTagSettingLoading}
                      >
                        {cms("common.button.update")}
                      </Button>
                    </InlineStack>
                    // <PageActions
                    //   primaryAction={{
                    //     content: cms("common.button.update"),
                    //     onAction: () => handleSubmit(),
                    //     disabled: !submitEnabled,
                    //     loading: updateTagSettingLoading,
                    //   }}
                    //   secondaryActions={[
                    //     {
                    //       content: cms("common.button.cancel"),
                    //       onAction: () => navigate("/setting"),
                    //     },
                    //   ]}
                    // />
                  )}
                </Form>
              </Collapsible>
            </Card.Section>
          </Card>
          {!updateAt && (
            <InlineStack align="space-between" blockAlign="center">
              <Button onClick={() => navigate("/setting")}>{cms("common.button.cancel")}</Button>
              <Button onClick={() => handleSubmit()} disabled={!submitEnabled} loading={updateTagSettingLoading}>
                {cms("common.button.submit")}
              </Button>
            </InlineStack>
            // <PageActions
            //   primaryAction={{
            //     content: cms("common.button.submit"),
            //     onAction: () => handleSubmit(),
            //     disabled: !submitEnabled,
            //     loading: updateTagSettingLoading,
            //   }}
            //   secondaryActions={[
            //     {
            //       content: cms("common.button.cancel"),
            //       onAction: () => navigate("/setting"),
            //     },
            //   ]}
            // />
          )}
          <div className="toast">
            <Toast message={message} setToast={setMessage} />
          </div>
        </Layout.AnnotatedSection>
        {isAdvanceActive && <AdvanceMetaFields metaData={metaData} setBanner={setBanner} />}
      </div>
    </>
  );
};

ProductMetafield.propTypes = advanceProp.type;

export default withFeature(withErrorBoundary(ProductMetafield), { feature: constant.PRODUCT_METAFIELD_SETTING });
